var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMailOutcomming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#F2FAE9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2267_22062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5H7C6.175 8.5 5.5 9.175 5.5 10V19C5.5 19.825 6.175 20.5 7 20.5H19C19.825 20.5 20.5 19.825 20.5 19V10C20.5 9.175 19.825 8.5 19 8.5H17.5",
    stroke: "#689F38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10L13 15.25L5.5 10",
    stroke: "#689F38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 7.75L13 5.5L10.75 7.75",
    stroke: "#689F38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6.4L13 11.5",
    stroke: "#689F38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2267_22062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailOutcomming);
export default __webpack_public_path__ + "static/media/icon_mail_outcomming.a4eaf7f0e8a7af29e0d744ef92b8aa64.svg";
export { ForwardRef as ReactComponent };